<label class="layout-row gap-2" [class.disabled]="isDisabled">
  <input
          type="radio"
          [name]="name"
          [value]="value"
          [checked]="checked"
          [disabled]="isDisabled"
          (change)="onInputChange()"
  />
  <span *ngIf="label">{{ label }}</span>
  <ng-content></ng-content>
</label>
